import userService from "../../../services/user.service";

async function getDepartments() {
  try {
    const response = await userService.getDepartments(-1, 0, "");
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to fetch departments."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error fetching departments:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function addDepartmentToDatabase({
  departmentName,
  departmentDescription,
  isActive,
}) {
  try {
    const payload = {
      name: departmentName,
      description: departmentDescription,
      active: isActive,
    };
    const response = await userService.addDepartment(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to add department."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error adding department:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

async function updateDepartmentInDatabase({
  departmentId,
  departmentName,
  departmentDescription,
  isActive,
}) {
  try {
    const payload = {
      id: departmentId,
      name: departmentName,
      description: departmentDescription,
      active: isActive,
    };
    const response = await userService.updateDepartment(payload);
    if (response.data && response.data.status) {
      console.log(response.data.result);
      return JSON.stringify(response.data.result);
    } else {
      return (
        JSON.stringify(response.data.message) || "Failed to update department."
      );
    }
  } catch (error) {
    const errorMessage =
      (error.response && error.response.data && error.response.data.message) ||
      error.message ||
      "An unexpected error occurred.";
    console.error("Error updating department:", errorMessage);
    return JSON.stringify(errorMessage);
  }
}

export default {
  addDepartmentToDatabase,
  getDepartments,
  updateDepartmentInDatabase,
  departmentTools: [
    {
      type: "function",
      function: {
        name: "getDepartments",
        description:
          "Fetch all departments from the database. You must give all departments in return. Don't skip any data unless told to do so.",
        parameters: {
          type: "object",
          properties: {},
        },
      },
    },
    {
      type: "function",
      function: {
        name: "updateDepartmentInDatabase",
        description: "Update an existing department in the database",
        parameters: {
          type: "object",
          properties: {
            departmentId: {
              type: "string",
              description: "The unique ID of the department to be updated",
            },
            departmentName: {
              type: "string",
              description: "Name of the department",
            },
            departmentDescription: {
              type: "string",
              description: "Description of the department",
            },
            isActive: {
              type: "boolean",
              description: "Whether the department is active or not",
            },
          },
          required: [
            "departmentId",
            "departmentName",
            "departmentDescription",
          ],
        },
      },
    },
    {
      type: "function",
      function: {
        name: "addDepartmentToDatabase",
        description: "Add a department to the database",
        parameters: {
          type: "object",
          properties: {
            departmentName: {
              type: "string",
              description: "Name of the department",
            },
            departmentDescription: {
              type: "string",
              description: "Description of the department",
            },
            isActive: {
              type: "boolean",
              description: "Whether the department is active or not",
            },
          },
          required: [
            "departmentName",
            "departmentDescription",
          ],
        },
      },
    },
  ],
};
